import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {CheckBoxOutlineBlankRounded, CheckBoxRounded} from 'views/icons';

const FilterDropdown = (props) => {
  const {
    multiSelect,
    onToggleOption,
    options,
    selectedKeys,
    title,
    width = '220px',
  } = props;

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        width,
        px: '14px',
        pt: '14px',
        pb: '20px',
        pr: '18px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #D9D8D5',
        borderRadius: '4px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '12px',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            width: '100%',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '11px',
            lineHeight: '14px',
            color: '#A8A49E',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
        {
          options.map((option) => {
            const isSelected = selectedKeys.includes(option.key);

            return (
              <Box
                key={option.key}
                onClick={() => onToggleOption(option)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: multiSelect ? '8px' : 0,
                  width: '100%',
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
              >
                {
                  multiSelect &&
                  (
                    isSelected ?
                    <CheckBoxRounded
                      sx={{
                        fontSize: '16px',
                        color: '#DA7955',
                      }}
                    /> :
                    <CheckBoxOutlineBlankRounded
                      sx={{
                        fontSize: '16px',
                        color: '#919191',
                      }}
                    />
                  )
                }
                <Typography
                  sx={{
                    fontStyle: 'normal',
                    fontWeight: isSelected && !multiSelect ? 600 : 400,
                    fontSize: '14px',
                    lineHeight: '18px',
                    color: isSelected && !multiSelect ? '#DA7955' : '#000000',
                  }}
                >
                  {option.label}
                </Typography>
              </Box>
            );
          })
        }
      </Box>
    </Box>
  );
};

FilterDropdown.propTypes = {
  multiSelect: PropTypes.bool,
  onToggleOption: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  selectedKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.string,
};

export default React.memo(FilterDropdown);
